import React from "react";
import "./AntiqueSaleBanner.css";

const AntiqueSaleBanner = ({ openModal }) => {
    return (
        <div className="banner-container">
            <div className="banner-overlay"></div>
            <div className="banner-content">
                <h1 className="banner-title">
                    VOULEZ-VOUS VENDRE VOS ANCIENS OBJETS ANTIQUES, AVEC LA GARANTIE D’OBTENIR LE MEILLEUR PRIX ?
                </h1>
                <p className="banner-subtext">
                    <span className="highlight">Demandez dès maintenant votre estimation gratuite et obtenez le meilleur prix garanti – exclusivement à Paris !</span>
                </p>
                <p className="banner-text">
                    Quelqu'un d'autre offre un meilleur prix ? Nous vous remboursons la différence !
                </p>
                <ul className="banner-list">
                    <li><span className="checkmark">✔️</span> Prix garanti le plus élevé !</li>
                    <li><span className="checkmark">✔️</span> Vous connaîtrez le prix dans les 12 heures !</li>
                    <li><span className="checkmark">✔️</span> Paiement immédiat !</li>
                </ul>
                <button className="banner-button" onClick={openModal}>
                    Demandez votre estimation &gt;&gt;
                </button>
            </div>
        </div>
    );
};

export default AntiqueSaleBanner;
